import React, { useEffect, useState } from "react";
import { Table, Button, Pagination, Modal } from "react-bootstrap";
import Layout from "../../../components/layout/Layout";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader";
import { useDispatch, useSelector } from "react-redux";
import { GrEdit } from "react-icons/gr";
import { AiOutlineClose } from "react-icons/ai";
import {
  getAllTimeSheet,
  getTimeSheetData,
} from "../../../redux/auth/authSlice";
import { useNavigate } from "react-router-dom";
import { RiDeleteBin6Line } from "react-icons/ri";
import {
  HourlyWages,
  otherCost,
  ExpenditureAccordingToTheAttachedPDF,
  costPerDayArticle,
  costPerWeekArticle,
  costPerMonthArticle,
  costAgreementArticle,
} from "./Articles";

// React Icons
import { AiOutlinePlus } from "react-icons/ai";
import { Helmet } from "react-helmet";
import { mobileScroll } from "common/FunctionUtils";
import { ARTICLE_NUMBERS, LOCALES } from "common/constants";

const CreatedTimeSheets = () => {
  const articlesNo = {
    HourlyWages: "92",
    otherCost: "93",
    ExpenditureAccordingToTheAttachedPDF: "2",
    costPerDay: "94",
    costPerWeek: "95",
    costPerMonth: "96",
    costAgreement: "97",
  };

  const { user, getAllTimeSheetData, isLoading } = useSelector(
    (data) => data.auth
  );

  // -----------------------------------translation-----------------------------------

  const { t } = useTranslation();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // -----------------------------------useState-----------------------------------

  const [show, setShow] = useState({
    id: null,
    data: [],
    ShowEditTimeSheet: false,
    ShowDeleteTimeSheet: false,
    onClickCreateInvoice: false,
  });
  const [loading, setLoading] = useState(false);
  const [timeSheetList, setTimeSheetList] = useState({
    data: [],
    pageNumber: 1,
  });

  useEffect(() => {
    if (user) {
      dispatch(getAllTimeSheet());
    }
    window.scrollTo(0, 0);
  }, []);

  // -----------------------------------Pagination-----------------------------------

  useEffect(() => {
    const slicedArray = getAllTimeSheetData?.slice(
      Number(timeSheetList.pageNumber + "0") - 10,
      Number(timeSheetList.pageNumber + "0") || getAllTimeSheetData.length - 1
    );
    setTimeSheetList((prevState) => ({ ...prevState, data: slicedArray }));
  }, [timeSheetList.pageNumber, getAllTimeSheetData]);

  // Edit Timesheet
  const handleEditTimeSheet =  async (id, { onClickCreateInvoice }) => {
    try {
      setLoading(true);
      const URL = `/timesheet/${id}`;
      const result = await axios.get(URL);
      if (result.status === 200) {
      const selectedTimeSheet = result?.data?.response;
      const {
        vat,
        amount,
        isFixed,
        customer,
        showDates,
        description,
        timeSheetFreelancers,
        timeSheetFileUpload,
        timeSheetWorkingHours,
      } = selectedTimeSheet;
      const filteredWorkingHours = timeSheetWorkingHours.filter((item) => {
        return (
          item?.articleNumber !== ARTICLE_NUMBERS.MILEAGE_TAX_FREE &&
          item?.articleNumber !== ARTICLE_NUMBERS.MILEAGE_WITH_TAX &&
          item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_OUT_TAX_FREE &&
          item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_OUT_WITH_TAX &&
          item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_HALF_DAY &&
          item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_HALF_DAY &&
          item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_FULL_DAY &&
          item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_FULL_DAY &&
          item?.articleNumber !== ARTICLE_NUMBERS.TRAVEL &&
          item?.articleNumber !== ARTICLE_NUMBERS.MATERIAL_VAT_TAX_FREE &&
          item?.articleNumber !== ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX
        );
      });
      const freelancer = timeSheetFreelancers.map((item) => ({
        amount: item.amount,
        userId: item.userId,
        signUpUser: item.freelancerDetails,
      }));
      let invoiceHours = [];
      if (freelancer && freelancer.length !== 0) {
        freelancer.forEach((freelancers) => {
          let array = [];
          filteredWorkingHours?.forEach((item) => {
            const {
              amountPerUnit,
              number,
              articleNumber,
              workingDate,
              userId,
              dateId,
            } = item;
            if (userId === freelancers?.userId) {
              array = [
                {
                  ...array[0],
                  [dateId ? dateId : workingDate.split("T")[0]]: {
                    units: number,
                    amount: amountPerUnit,
                    article:
                    articleNumber === articlesNo.HourlyWages
                      ? HourlyWages
                      : articleNumber === articlesNo.otherCost
                      ? otherCost
                      : articleNumber === articlesNo.costPerDay
                      ? costPerDayArticle
                      : articleNumber === articlesNo.costPerWeek
                      ? costPerWeekArticle
                      : articleNumber === articlesNo.costPerMonth
                      ? costPerMonthArticle
                      : articleNumber === articlesNo.costAgreement
                      ? costAgreementArticle
                      : articleNumber ===
                        articlesNo.ExpenditureAccordingToTheAttachedPDF
                      ? ExpenditureAccordingToTheAttachedPDF
                      : "",
                  },
                },
              ];
            }
          });
          invoiceHours.push(...array);
        });
      } else {
        let array = [];
        filteredWorkingHours?.forEach((item) => {
          const { amountPerUnit, number, articleNumber, workingDate, dateId } =
            item;
          array = [
            {
              ...array[0],
              [dateId ? dateId : workingDate.split("T")[0]]: {
                units: number,
                amount: amountPerUnit,
                article:
                articleNumber === articlesNo.HourlyWages
                  ? HourlyWages
                  : articleNumber === articlesNo.otherCost
                  ? otherCost
                  : articleNumber === articlesNo.costPerDay
                  ? costPerDayArticle
                  : articleNumber === articlesNo.costPerWeek
                  ? costPerWeekArticle
                  : articleNumber === articlesNo.costPerMonth
                  ? costPerMonthArticle
                  : articleNumber === articlesNo.costAgreement
                  ? costAgreementArticle
                  : articleNumber ===
                    articlesNo.ExpenditureAccordingToTheAttachedPDF
                  ? ExpenditureAccordingToTheAttachedPDF
                  : "",
              },
            },
          ];
        });
        invoiceHours.push(...array);
      }
      const invoiceFile = Array(freelancer.length).fill([]);
      const element = invoiceHours.splice(invoiceHours.length - 1, 1)[0];
      invoiceHours.splice(0, 0, element);
      freelancer.splice(freelancer.length - 1, 1);
      const otherArticles = timeSheetWorkingHours
        ?.filter((item) => {
          return (
            item?.articleNumber === ARTICLE_NUMBERS.MILEAGE_TAX_FREE ||
            item?.articleNumber === ARTICLE_NUMBERS.MILEAGE_WITH_TAX ||
            item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_OUT_TAX_FREE ||
            item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_OUT_WITH_TAX ||
            item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_HALF_DAY ||
            item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_HALF_DAY ||
            item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_FULL_DAY ||
            item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_FULL_DAY ||
            item?.articleNumber === ARTICLE_NUMBERS.TRAVEL ||
            item?.articleNumber === ARTICLE_NUMBERS.MATERIAL_VAT_TAX_FREE ||
            item?.articleNumber === ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX
          );
        })
      const selectedData = {
        selectedCustomer: customer,
        description,
        freelancer,
        invoiceHours,
        showDates,
        id,
        vat,
        isFixed,
        amount,
        invoiceFile,
        otherArticles,
        timeSheetFileUpload
      };
      setLoading(false);
      dispatch(getTimeSheetData(selectedData));
      const selectedTimeSheetFreelancers =
        selectedTimeSheet?.timeSheetFreelancers?.filter(
          (items) => items.userId !== user.userId
        );
      setShow((prevState) => ({
        ...prevState,
        onClickCreateInvoice,
        ShowEditTimeSheet: true,
        data: {
          ...selectedTimeSheet,
          timeSheetFreelancers: selectedTimeSheetFreelancers,
        },
      }));
    } else {
      setLoading(false);
      toast.error(t("Something went wrong please try again."));
    }
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message);
    }
    };

  const handleDeleteTimeSheet = async (id) => {
    try {
      setLoading(true);
      await axios.delete(`/TimeSheet/${id}`);
      setLoading(false);
      dispatch(getAllTimeSheet());
      setShow((prevState) => ({ ShowDeleteTimeSheet: false }));
      toast.success(t("Time sheet has been deleted successfully"));
    } catch (error) {
      if (error?.response?.data) {
        toast.error(t(error?.response?.data?.message));
      } else {
        toast.error(t(error?.message));
      }
    } finally {
      setLoading(false);
    }
  };
  const language = localStorage.getItem("i18nextLng");

  useEffect(() => {
    mobileScroll();
  }, []);

  return (
    <Layout
      className="p-4 mt-5 freelance-bg invoice-space info-space"
      showSidebar
      bgcolor
    >
      <Helmet>
        {language === LOCALES.EN_US ? (
          <link
            rel="canonical"
            href="https://invozio.com/dashboard/economy/created-time-sheets"
          />
        ) : (
          <link
            rel="canonical"
            href="https://invozio.com/instrumentbrada/ekonomi/skapade-tidrapporter"
          />
        )}
      </Helmet>
      {(isLoading || loading) && <Loader />}

      <div className="time_wrapper">
        <h4 className="accident_ins font-weight-bold">{t("My Timesheets")}</h4>
        <p className="mb-0">
          {t("Here you can see your created timesheets.")}
        </p>
        <p className="mb-3">
          {t(
            "The timesheet you have created will be deleted automatically after"
          )}{' '}45 {t("days from the date of creation.")}
        </p>
      </div>

      <div className="table-div">
        <Table striped bordered hover>
          <thead>
            <tr>
              <th className="invoice_tabeletext">{t("Id")}</th>
              <th className="invoice_tabeletext">{t("Customer Name")}</th>
              <th className="invoice_tabeletext">{t("Customer Email")}</th>
              <th className="invoice_tabeletext">{t("Created Date")}</th>
              <th className="invoice_tabeletext">{t("Last Updated Date")}</th>
              <th className="invoice_tabeletext">{t("Action")}</th>
            </tr>
          </thead>
          <tbody>
            {timeSheetList?.data?.map((items, index) => {
              return (
                <tr key={index}>
                  <td>{items.id}</td>
                  <td>{items.customer?.name}</td>
                  <td>{items.customer?.email}</td>
                  <td>{items.createdDate?.split("T")[0]}</td>
                  <td>{items.updatedDate?.split("T")[0]}</td>
                  <td className="d-flex actionlast">
                    <Button
                      id="top"
                      data-toggle="tooltip"
                      data-placement="top"
                      title={t("Create Invoice")}
                      className="outlines-primary mt-2 create_time_invoice color-bg mt-2 ml-2 mb-2"
                      onClick={() =>
                        handleEditTimeSheet(items.id, {
                          onClickCreateInvoice: true,
                        })
                      }
                    >
                      <AiOutlinePlus />
                    </Button>
                    <div className="color-bg mt-2 ml-2 mb-2">
                      <GrEdit
                        id="top"
                        data-toggle="tooltip"
                        data-placement="top"
                        title={t("Edit")}
                        className="cursor-pointer"
                        onClick={() =>
                          handleEditTimeSheet(items.id, {
                            onClickCreateInvoice: false,
                          })
                        }
                        size={24}
                      />
                    </div>
                    <div className="color-bg m-2">
                      <RiDeleteBin6Line
                        id="top"
                        data-toggle="tooltip"
                        data-placement="top"
                        title={t("Delete")}
                        className="cursor-pointer"
                        onClick={() =>
                          setShow((prevState) => ({
                            ...prevState,
                            ShowDeleteTimeSheet: true,
                            id: items.id,
                          }))
                        }
                        size={24}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>

      <Pagination className="paginationInvoice">
        {getAllTimeSheetData?.length > 10 &&
          new Array(Math.ceil(getAllTimeSheetData?.length / 10))
            .fill(undefined)
            .map((_, key) => (
              <Pagination.Item
                activeLabel=""
                active={timeSheetList.pageNumber - 1 === key}
                key={key}
                onClick={() => {
                  setTimeSheetList((prevState) => ({
                    ...prevState,
                    pageNumber: key + 1,
                  }));
                }}
              >
                {key + 1}
              </Pagination.Item>
            ))}
      </Pagination>

      {(show.ShowEditTimeSheet || show.ShowDeleteTimeSheet) && (
        <Modal show={true} onHide={() => setShow({ ShowEditTimeSheet: false })}>
          <Modal.Header>
            <Modal.Title>
              {show.ShowDeleteTimeSheet
                ? t("Delete Timesheet")
                : show.onClickCreateInvoice
                ? ""
                : t("Edit Timesheet")}
            </Modal.Title>
            <AiOutlineClose
              className="ml-auto cursor-pointer"
              size={24}
              onClick={() => setShow({ ShowEditTimeSheet: false })}
            />
          </Modal.Header>
          <Modal.Body>
            {show.ShowDeleteTimeSheet ? (
              t("Are you sure you want to delete this timesheet?")
            ) : (
              <div className="page-content EconomyInvoices">
                <div className="invoice-details-container">
                  <div className="invoice-details-part-container flex-column w-100">
                    <span className="invoice-details-title">
                      {!show.onClickCreateInvoice &&
                        t("YOU ARE GOING TO EDIT THIS TIME SHEET")}
                    </span>
                    <div className="invoice-details-wrapper new_clor pt-20">
                      <div className="invoice-details-row-container">
                        <div className="invoice-details-part-container w-100 f-culm">
                          <div className="invoice-details-row-column padding">
                            <div className="invoice-details-title-head">
                              <span>{t("CUSTOMER INFORMATION")}</span>
                            </div>
                            <div className="invoice-details-row">
                              <p className="mb-2">{show.data.customer?.name}</p>
                            </div>
                            <div className="invoice-details-row">
                              <p className="mb-2">
                                #-{show.data?.customer?.zipCode}
                              </p>
                            </div>
                            <div className="invoice-details-row">
                              <p className="mb-2">
                                {show.data?.customer?.co} ,{" "}
                                {show.data?.customer?.city}
                              </p>
                            </div>
                            <div className="invoice-details-row ">
                              <p className="mb-2 d-flex">
                                {show.data?.customer?.country}
                              </p>
                            </div>
                            <div className="invoice-details-row">
                              {" "}
                              <p className="mb-2">
                                <strong>{t("Reference")} : </strong>
                                {show.data?.customer?.reference}
                              </p>
                            </div>
                            <div className="invoice-details-row">
                              <p className="mb-2">
                                <strong>{t("Email Address")} : </strong>
                                <span title={show.data?.customer?.email}>
                                  {show.data?.customer?.email
                                    ?.substring(0, 25)
                                    .concat("...")}
                                </span>
                              </p>
                            </div>
                          </div>
                          <div className="invoice-details-column-divider"></div>
                          <div className="invoice-details-row-column padding">
                            <div className="invoice-details-title-head">
                              <span>{t("SELECTED FREELANCERS")}</span>
                            </div>
                            <div className="invoice-details-row">
                              <p className="mb-2">
                                <strong>
                                  {show.data.timeSheetFreelancers.length === 0
                                    ? t("No freelancers selected")
                                    : t("email") + " :"}
                                </strong>
                              </p>
                            </div>
                            {show.data.timeSheetFreelancers.map(
                              (item, index) => (
                                <div key={index} className="new_clor">
                                  {index + 1}
                                  {" ) "}
                                  <span title={item.freelancerDetails?.email}>
                                    {item.freelancerDetails?.email
                                      .substring(0, 16)
                                      .concat("...")}
                                  </span>
                                </div>
                              )
                            )}
                          </div>
                        </div>
                        <div className="invoice-view-activity-status-container"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <button
              className="outline_btn_new"
              variant="secondary"
              onClick={() => {
                setShow({ ShowEditTimeSheet: false });
                dispatch(getTimeSheetData({}));
              }}
            >
              {t("Cancel")}
            </button>
            <Button
              className="new_theme_btn"
              onClick={() => {
                show.ShowDeleteTimeSheet
                  ? handleDeleteTimeSheet(show.id)
                  : show.onClickCreateInvoice
                  ? language === LOCALES.EN_US
                    ? navigate(`/dashboard/invoice-tool?lang=${LOCALES.EN_US}&timesheet=true`)
                    : navigate(
                        `/instrumentbrada/faktura-verktyg?lang=${LOCALES.SV_SE}&tidrapport=true`
                      )
                  : language === LOCALES.EN_US
                  ? navigate(`/dashboard/time-sheet?lang=${LOCALES.EN_US}`)
                  : navigate(`/instrumentbrada/tidrapport?lang=${LOCALES.SV_SE}`);
              }}
            >
              {show.onClickCreateInvoice
                ? t("Go to create invoice")
                : show.ShowDeleteTimeSheet
                ? t("Delete")
                : t("Edit")}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </Layout>
  );
};
export default CreatedTimeSheets;
